<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "payment_control_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<sp-payment-method-settings
    [itemForm]="itemForm"
    [paymentMethods]="paymentMethods()"
    [shopCurrency]="shopCurrency()"
    [paymentElements]="paymentElements().value"
    [showRroSettings]="false"
    [isDisabledPaymentMethodSelectForCart]="isDisabledPaymentMethodSelect()"
/>

<web-settings-footer [isSaveDisabled]="saveDisablePredicate" (saveEvent)="onSave()" (cancelEvent)="onCancel()" />
